import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "../../hooks/useTranslation";
import { LanguageSelector } from "../shared/LanguageSelector";
import { DoctorStripFilters, } from "../appointment/DoctorStripFilters";
export function BookingHeroHeader({ variant = "appointment", isMobile = false, filters, }) {
    const { t, language, changeLanguage } = useTranslation("appointment");
    const title = variant === "queue"
        ? t("widgetTitleQueue", "Join the Queue")
        : t("widgetTitle", "Book an Appointment");
    const subtitle = variant === "queue"
        ? t("widgetSubtitleQueue", "Select a doctor and secure your spot in the queue.")
        : t("widgetSubtitle", "Find the right specialist and schedule your visit in just a few clicks.");
    const selectLanguageLabel = t("selectLanguage", "Language");
    return (_jsx(Box, { component: "header", sx: {
            flexShrink: 0,
            bgcolor: "transparent",
            px: isMobile ? 0.5 : 1,
            py: isMobile ? 0.5 : 1,
        }, children: _jsxs(Stack, { direction: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "flex-end", justifyContent: "space-between", spacing: isMobile ? 1.25 : 2, children: [_jsxs(Box, { sx: { minWidth: 0, flex: 1 }, children: [_jsx(Typography, { component: "h1", sx: {
                                fontWeight: 600,
                                letterSpacing: 0,
                                lineHeight: 1.2,
                                color: "primary.main",
                                fontSize: isMobile ? 22 : { sm: 26, md: 32 },
                                m: 0,
                            }, children: title }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: {
                                mt: 0.5,
                                lineHeight: 1.5,
                                fontSize: isMobile ? 12 : 14,
                            }, children: subtitle })] }), _jsxs(Stack, { direction: "row", alignItems: "center", spacing: isMobile ? 0.75 : 1.25, useFlexGap: true, flexWrap: isMobile ? "wrap" : "nowrap", sx: {
                        flexShrink: 0,
                        gap: isMobile ? 0.75 : 1.25,
                        width: isMobile ? "100%" : undefined,
                        justifyContent: isMobile ? "flex-start" : "flex-end",
                    }, children: [filters && (_jsx(DoctorStripFilters, { filters: filters, isMobile: isMobile })), _jsx(LanguageSelector, { language: language, onChange: changeLanguage, label: selectLanguageLabel, isMobile: isMobile, shape: "rectangular" })] })] }) }));
}
